import React from "react";
import { Link } from "react-router-dom";
import { usePageBootstrap } from "../../hooks/useBootstrapList";
import { useBootstrapWS } from "../../hooks/useBootstrapWS";
import { PageHeader, KpiTile, SectionCard, StatePill } from "../../components/Ui";
import { PackageOpen, ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function UnloadingSupervisorDashboard() {
  const { data, reload } = usePageBootstrap({
    path: "/dashboard/bootstrap",
    wsTypes: ["purchase", "stack"],
  });
  useBootstrapWS(["purchase", "stack"], reload);

  const queue = data?.queue || [];
  const kpis = data?.kpis || {};

  return (
    <div className="space-y-5 sm:space-y-6" data-testid="unloading-supervisor-dashboard">
      <PageHeader
        eyebrow="Unloading Supervisor"
        title="Unloading Desk"
        description="Trucks cleared for unload — record bags per Houdi or Stack and request mid weigh when needed."
        actions={
          <div className="flex flex-col sm:flex-row gap-2">
            <Button asChild variant="outline" className="min-h-11">
              <Link to="/store/grn">Store GRN</Link>
            </Button>
            <Button asChild className="bg-bansal-sage hover:bg-bansal-sageDark text-white min-h-11">
              <Link to="/unloading">
                <PackageOpen className="h-4 w-4 mr-2" />
                Open unloading
              </Link>
            </Button>
          </div>
        }
      />

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        <KpiTile label="Ready" value={kpis.approved ?? 0} sub="Approved trucks" accent testId="unload-sup-kpi-ready" />
        <KpiTile label="On floor" value={kpis.unloading ?? 0} sub="Unloading / mid weigh" testId="unload-sup-kpi-active" />
        <KpiTile label="On hold" value={kpis.on_hold ?? 0} sub="Quality hold" testId="unload-sup-kpi-hold" />
      </div>

      <SectionCard title="Your unloading queue" testId="unload-sup-queue">
        {queue.length === 0 ? (
          <p className="text-sm text-muted-foreground py-6 text-center">No trucks ready for unloading.</p>
        ) : (
          <div className="space-y-2">
            {queue.slice(0, 10).map((p) => (
              <Link
                key={p.id}
                to="/unloading"
                className="flex items-center justify-between gap-3 rounded-xl border border-border px-3 py-3 hover:bg-accent/60"
              >
                <div className="min-w-0">
                  <div className="font-mono text-sm">{p.code}</div>
                  <div className="text-sm truncate">{p.party_name}</div>
                  {p.assigned_to ? (
                    <div className="text-[10px] text-muted-foreground mt-0.5">Routed to: {p.assigned_to}</div>
                  ) : null}
                </div>
                <StatePill state={p.state} />
              </Link>
            ))}
          </div>
        )}
        <Link to="/unloading" className="inline-flex items-center gap-1 text-xs link-brand mt-3">
          Record unloading <ArrowRight className="h-3 w-3" />
        </Link>
      </SectionCard>
    </div>
  );
}
